import { z } from "zod";
const rawAttributesImageSchema = z.preprocess(
  (input) => {
    if (input && typeof input === "object" && !Array.isArray(input)) {
      const obj = input;
      if ("darkModeSrc" in obj) {
        obj["src-dark"] = obj["src-dark"] ?? obj.darkModeSrc;
      }
      return obj;
    }
    return input;
  },
  z.object({
    src: z.string(),
    // normalize via preprocess above if provided as darkModeSrc
    "src-dark": z.string().optional(),
    width: z.coerce.number().min(0).optional(),
    height: z.coerce.number().min(0).optional(),
    alt: z.string().optional(),
    caption: z.string().optional(),
    href: z.string().optional(),
    size: z.enum(["actual", "custom", "full"]).default("actual"),
    isTipTap: z.boolean().optional()
  })
);
const attributesImageSchema = rawAttributesImageSchema;
export {
  attributesImageSchema
};
//# sourceMappingURL=attributes.js.map
